<footer class="flex flex-col gap-8 p-4">
  <div
    class="flex flex-col items-start justify-between gap-12 md:flex-row md:gap-20"
  >
    <div class="flex flex-col gap-8">
      <div class="flex cursor-pointer items-center">
        <img
          class="mr-3 h-8 w-auto rounded-lg"
          [src]="'/assets/logo.svg'"
          alt="Logo"
        />
        <span class="text-xl font-bold">Capawesome Cloud</span>
      </div>
      <div class="flex gap-4">
        <!-- <img
          class="h-12 w-auto"
          [src]="'/assets/images/badges/made-in-germany.png'"
          alt="Made in Germany"
        /> -->
        <a [href]="trustCenterUrl" target="_blank" rel="noopener noreferrer">
          <img
            class="h-12 w-auto"
            [src]="'/assets/images/badges/gdpr.svg'"
            alt="GDPR Compliant"
          />
        </a>
        <a [href]="trustCenterUrl" target="_blank" rel="noopener noreferrer">
          <img
            class="h-12 w-auto"
            [src]="'/assets/images/badges/iso27001.svg'"
            alt="ISO 27001 Certified"
          />
        </a>
        <a [href]="trustCenterUrl" target="_blank" rel="noopener noreferrer">
          <img
            class="h-12 w-auto"
            [src]="'/assets/images/badges/soc2.svg'"
            alt="SOC 2 Compliant"
          />
        </a>
        <a
          href="https://ionic.io/developer-experts"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            class="h-12 w-auto"
            [src]="'/assets/images/badges/ide-light.png'"
            alt="Ionic Developer Expert"
          />
        </a>
      </div>
      <div class="max-w-xs text-sm text-text-secondary">
        Yearly third-party audits and continuous monitoring to ensure a high
        level of security and compliance.
      </div>
    </div>
    <div
      class="grid flex-1 grid-cols-1 items-start justify-between gap-12 sm:grid-cols-2 lg:grid-cols-4"
    >
      @for (navColumn of navColumns; track $index) {
        <div class="flex flex-col gap-8">
          @for (navGroup of navColumn.items; track $index) {
            <div class="flex flex-col gap-4">
              <span class="text-xl font-bold">{{ navGroup.label }}</span>
              <ul class="flex flex-col gap-2">
                @for (navItem of navGroup.items; track $index) {
                  <li>
                    <a
                      class="cursor-pointer text-base text-text-primary hover:text-text-secondary"
                      [href]="navItem.href"
                      [target]="navItem.target || '_self'"
                      >{{ navItem.label }}</a
                    >
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      }
    </div>
  </div>
  <div class="border-t border-gray-200 py-6">
    <div>
      Copyright &copy; 2022 - {{ currentYear }} Genz IT Solutions GmbH. All
      rights reserved.
    </div>
  </div>
</footer>
